"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../../constants/Field");
var DataItem_1 = require("../common/base/DataItem");
var DataType_1 = require("../common/base/DataType");
var lodash_1 = require("lodash");
var Triggers = /** @class */ (function () {
    function Triggers() {
        this.init();
    }
    Triggers.fromJson = function (json) {
        var triggers = new Triggers();
        if (json === undefined) {
            return triggers;
        }
        triggers.updateTimeTrigger(Triggers.fromTimeJson(json[Field_1.FIELD.TIME]));
        triggers.updateVariableChangeTrigger(Triggers.fromVariableChangeJson(json[Field_1.FIELD.VARIABLECHANGE]));
        triggers.updateEventTrigger(Triggers.fromEventChangeJson(json[Field_1.FIELD.EVENTTRIGGER]));
        triggers.updateAlarmTrigger(Triggers.fromVAlarmChangeJson(json[Field_1.FIELD.ALARMTRIGGER]));
        return triggers;
    };
    Triggers.fromTimeJson = function (timeJson) {
        if (timeJson !== undefined) {
            return DataItem_1.DataItem.fromJson(Field_1.FIELD.TIME, timeJson);
        }
        else {
            return new DataItem_1.DataItem(Field_1.FIELD.TIME, DataType_1.DataType.string);
        }
    };
    Triggers.fromVariableChangeJson = function (variableChangeJson) {
        if (variableChangeJson !== undefined) {
            var variableChangeTriggers = lodash_1.map(Object.keys(variableChangeJson), function (vcTriggerName) {
                return DataItem_1.DataItem.fromJson(vcTriggerName, variableChangeJson[vcTriggerName]);
            });
            return variableChangeTriggers;
        }
        else {
            return [];
        }
    };
    Triggers.fromEventChangeJson = function (eventChangeJson) {
        if (eventChangeJson !== undefined) {
            var eventChangeTriggers = lodash_1.map(Object.keys(eventChangeJson), function (vcTriggerName) {
                return DataItem_1.DataItem.fromJson(vcTriggerName, eventChangeJson[vcTriggerName]);
            });
            return eventChangeTriggers;
        }
        else {
            return [];
        }
    };
    Triggers.fromVAlarmChangeJson = function (alarmChangeJson) {
        if (alarmChangeJson !== undefined) {
            var alarmChangeTriggers = lodash_1.map(Object.keys(alarmChangeJson), function (vcTriggerName) {
                return DataItem_1.DataItem.fromJson(vcTriggerName, alarmChangeJson[vcTriggerName]);
            });
            return alarmChangeTriggers;
        }
        else {
            return [];
        }
    };
    Triggers.prototype.toJson = function (includeOnlyVariableData) {
        var variableChangeTriggers = this.variableChangeTriggersToJson(includeOnlyVariableData);
        var json = Object.create(null);
        var timeTriggerJson = this.timeTriggerToJson(includeOnlyVariableData);
        var eventTriggerJson = this.eventTriggersToJson(includeOnlyVariableData);
        var alarmTriggerJson = this.alarmTriggersToJson(includeOnlyVariableData);
        if (!lodash_1.isEmpty(timeTriggerJson)) {
            json[Field_1.FIELD.TIME] = timeTriggerJson;
        }
        if (!lodash_1.isEmpty(variableChangeTriggers)) {
            json[Field_1.FIELD.VARIABLECHANGE] = variableChangeTriggers;
        }
        if (!lodash_1.isEmpty(eventTriggerJson)) {
            json[Field_1.FIELD.EVENTTRIGGER] = eventTriggerJson;
        }
        if (!lodash_1.isEmpty(alarmTriggerJson)) {
            json[Field_1.FIELD.ALARMTRIGGER] = alarmTriggerJson;
        }
        return json;
    };
    Triggers.prototype.updateTimeTrigger = function (time) {
        this.time = time;
    };
    Triggers.prototype.updateVariableChangeTrigger = function (variableChange) {
        this.variableChange = variableChange;
    };
    Triggers.prototype.updateEventTrigger = function (eventData) {
        this.eventTrigger = eventData;
    };
    Triggers.prototype.updateAlarmTrigger = function (alarmData) {
        this.alarmTrigger = alarmData;
    };
    Triggers.prototype.timeTriggerToJson = function (includeOnlyValueOrLink) {
        if ((this.time.value !== undefined)) {
            return this.time.toJson(includeOnlyValueOrLink);
        }
        return Object.create(null);
    };
    Triggers.prototype.variableChangeTriggersToJson = function (includeOnlyVariableData) {
        var variableChangeTriggers = Object.create(null);
        lodash_1.map(this.variableChange, function (vc) {
            var vcTrigger = vc.toJson(includeOnlyVariableData);
            if (!vcTrigger[Field_1.FIELD.VALUE]) {
                vcTrigger[Field_1.FIELD.VALUE] = vc.getDefaultItemValue(false);
            }
            variableChangeTriggers[vc.name] = vcTrigger;
        });
        return variableChangeTriggers;
    };
    Triggers.prototype.eventTriggersToJson = function (includeOnlyVariableData) {
        var eventTriggers = Object.create(null);
        lodash_1.map(this.eventTrigger, function (vc) {
            var vcTrigger = vc.toJson(includeOnlyVariableData);
            if (!vcTrigger[Field_1.FIELD.VALUE]) {
                vcTrigger[Field_1.FIELD.VALUE] = vc.getDefaultItemValue(false);
            }
            eventTriggers[vc.name] = vcTrigger;
        });
        return eventTriggers;
    };
    Triggers.prototype.alarmTriggersToJson = function (includeOnlyVariableData) {
        var alarmTriggers = Object.create(null);
        lodash_1.map(this.alarmTrigger, function (vc) {
            var vcTrigger = vc.toJson(includeOnlyVariableData);
            if (!vcTrigger[Field_1.FIELD.VALUE]) {
                vcTrigger[Field_1.FIELD.VALUE] = vc.getDefaultItemValue(false);
            }
            alarmTriggers[vc.name] = vcTrigger;
        });
        return alarmTriggers;
    };
    Triggers.prototype.init = function () {
        this.time = new DataItem_1.DataItem(Field_1.FIELD.TIME, DataType_1.DataType.string);
        this.time.value = ('');
        this.variableChange = [];
        this.eventTrigger = [];
        this.alarmTrigger = [];
    };
    return Triggers;
}());
exports.Triggers = Triggers;
//# sourceMappingURL=Triggers.js.map